import '@fontsource/jost/400.css';
import '@fontsource/jost/700.css';
import './src/css/style.css';
import { bootstrapConsent, trackPageView } from './src/consent';

// Starts the trackers if a decision was already stored on a previous visit.
export const onClientEntry = () => {
    bootstrapConsent();
};

// Fires on the initial render and on every client-side route change.
export const onRouteUpdate = ({ location }) => {
    trackPageView(location);
};
